import { FormMode } from '@/components/tripBookingPage/tripBooking.ts';
import type { MaybeEmptyString, TripType } from '@/types';
import { isRef, type MaybeRef } from 'vue';

/**
 * Détermine, de façon générale seulement, si le formulaire est en mode "modification",
 * peu importe s'il s'agit d'un segment ou d'un déplacement complet.
 */
function isModificationMode(mode: FormMode): boolean {
  return mode === FormMode.Modification || mode === FormMode.LegModification;
}

/**
 * Détermine la condition pour l'affichage de contenu pour le retour dans le formulaire de réservation
 * */
function renderRoundTrip(tripType: MaybeEmptyString<TripType>, formMode: MaybeRef<FormMode>) {
  const mode = isRef(formMode) ? formMode.value : formMode;

  return tripType === 'roundTrip' && mode !== FormMode.LegModification;
}

export {
  isModificationMode,
  renderRoundTrip,
};
